// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./locales/en/translation.json";
import translationFR from "./locales/fr/translation.json";

const resources = {
  en: { translation: translationEN },
  fr: { translation: translationFR },
};

// --- Patch de migration: normaliser ce qui est déjà en storage ---
(function normalizeStoredLang() {
  const stored = localStorage.getItem("i18nextLng");
  if (stored && stored.length > 2) {
    const short = stored.slice(0, 2).toLowerCase(); // 'fr-CA' -> 'fr'
    localStorage.setItem("i18nextLng", short);
    // on ne change pas la langue ici; i18next s’en charge à l’init
    document.documentElement.lang = short;
  }
})();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fr",
    supportedLngs: ["fr", "en"],
    load: "languageOnly",
    cleanCode: true,
    detection: {
      order: ["localStorage", "cookie", "htmlTag", "navigator"],
      caches: ["localStorage", "cookie"],
    },
    interpolation: { escapeValue: false },
  });

// Synchronise l’attribut <html lang="..."> même si la langue change plus tard
i18n.on("languageChanged", (lng) => {
  const short = (lng || "fr").slice(0, 2).toLowerCase();
  document.documentElement.lang = short;
  // s'assurer que le storage reste en 2 lettres même si on reçoit 'en-US'
  localStorage.setItem("i18nextLng", short);
});

export default i18n;
